import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/client/listclient.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteClient,
  getClients,
  getClientsWithStatus,
  sendAllClientsReport,
} from "../../services";
import { toggle } from "../../redux";
import { FaSearch } from "react-icons/fa";
import { coachRoutes } from "../../routers/CoachRouters";
import InfiniteScroll from "react-infinite-scroll-component";
import Delete from "../../assets/exercise/delete.png";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/exercise/deletepopup.png";
import Swal from "sweetalert2";

const LIMIT = 10;

const ListClient = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const [displayedClients, setDisplayedClients] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  // Refs for table alignment
  const headerTableRef = useRef(null);
  const scrollableContainerRef = useRef(null);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  // Calculate scrollbar width and apply compensation
  useEffect(() => {
    const calculateScrollbarWidth = () => {
      const container = scrollableContainerRef.current;
      if (container) {
        const scrollbarWidth = container.offsetWidth - container.clientWidth;
        setScrollbarWidth(scrollbarWidth);

        // Apply padding to header table to compensate for scrollbar
        if (headerTableRef.current) {
          headerTableRef.current.style.paddingRight = `${scrollbarWidth}px`;
        }
      }
    };

    // Calculate on mount and window resize
    calculateScrollbarWidth();
    window.addEventListener("resize", calculateScrollbarWidth);

    return () => {
      window.removeEventListener("resize", calculateScrollbarWidth);
    };
  }, [displayedClients.length]);

  // Recalculate when content changes
  useEffect(() => {
    const timer = setTimeout(() => {
      const container = scrollableContainerRef.current;
      if (container) {
        const scrollbarWidth = container.offsetWidth - container.clientWidth;
        setScrollbarWidth(scrollbarWidth);

        if (headerTableRef.current) {
          headerTableRef.current.style.paddingRight = `${scrollbarWidth}px`;
          headerTableRef.current.style.backgroundColor = "#1f1f1f";
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [displayedClients]);

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  const fetchClients = async (
    pageNum = page,
    query = "",
    year = selectedYear,
  ) => {
    if (loading) return;

    try {
      setLoading(true);

      const newClients = await getClientsWithStatus(
        false,
        pageNum,
        LIMIT,
        query,
        year,
      );
      console.log("Fetched Clients:", newClients);

      if (newClients && Array.isArray(newClients) && newClients.length > 0) {
        const processedClients = newClients.map((client) => ({
          ...client,
          fitness: client.fitness || {
            1: {
              biometrics: false,
              exercises: false,
              exercisesCompleted: false,
            },
            2: {
              biometrics: false,
              exercises: false,
              exercisesCompleted: false,
            },
            3: {
              biometrics: false,
              exercises: false,
              exercisesCompleted: false,
            },
            4: {
              biometrics: false,
              exercises: false,
              exercisesCompleted: false,
            },
          },
        }));

        setDisplayedClients((prev) => [...prev, ...processedClients]);
        setPage((prev) => prev + 1);
      } else {
        console.log("No more Clients to fetch");
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching Clients:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  // Initial fetch will be triggered when yearOptions load and selectedYear is set

  const handleSearch = async (e, year = selectedYear) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "" && year === "all") {
        setDisplayedClients([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchClients(1, "", year);
        }, 1);
      } else {
        const newClients = await getClientsWithStatus(
          false,
          1,
          -1,
          query,
          year,
        );
        if (Array.isArray(newClients)) {
          const processedClients = newClients.map((client) => ({
            ...client,
            fitness: client.fitness || {
              1: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              2: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              3: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              4: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
            },
          }));
          setDisplayedClients(processedClients);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const handleYearFilter = async (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    setDisplayedClients([]);
    setPage(1);
    setHasMore(true);

    try {
      if (year === "all" && searchQuery.trim() === "") {
        setTimeout(() => {
          fetchClients(1, searchQuery, year);
        }, 1);
      } else {
        const newClients = await getClientsWithStatus(
          false,
          1,
          -1,
          searchQuery,
          year,
        );
        if (Array.isArray(newClients)) {
          const processedClients = newClients.map((client) => ({
            ...client,
            fitness: client.fitness || {
              1: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              2: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              3: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
              4: {
                biometrics: false,
                exercises: false,
                exercisesCompleted: false,
              },
            },
          }));
          setDisplayedClients(processedClients);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Year filter error:", error);
    }
  };

  const handleViewReport = (clientId) => {
    navigate(`/client-report/${clientId}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button
            id="customCloseButton"
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img
              src=${Close_Button}
              alt="Close"
              style="width: 40px; height: 40px;"
            />
          </button>
          <img
            src=${Suceess}
            alt="Success"
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button
            id="cancel"
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button
            id="delete"
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const success = await deleteClient(id);
          if (success) {
            window.location.reload(coachRoutes.listClient);
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  // Updated function to handle three states
  const renderStatusIcon = (status) => {
    if (status === true) {
      return (
        <span className={Styles.statusCompleted} title="Completed">
          ✔
        </span>
      );
    } else if (status === "partial") {
      return (
        <span className={Styles.statusPartial} title="Partially completed">
          ◐
        </span>
      );
    } else {
      return (
        <span className={Styles.statusIncomplete} title="Not completed">
          ✖
        </span>
      );
    }
  };

  // Updated function to get exercise status with three states
  const getExerciseStatus = (client, blockNumber) => {
    if (!client.fitness || !client.fitness[blockNumber.toString()]) {
      return false;
    }

    const blockData = client.fitness[blockNumber.toString()];

    // If exercisesCompleted is true, it's fully completed
    if (blockData.exercisesCompleted === true) {
      return true;
    }

    if (
      blockData.exercises === true &&
      blockData.exercisesCompleted === false
    ) {
      return "partial";
    }

    // Otherwise, it's incomplete
    return false;
  };

  // Keep the original function for biometrics (binary status)
  const getFitnessData = (client, blockNumber, type) => {
    if (!client.fitness || !client.fitness[blockNumber.toString()]) {
      return false;
    }
    return client.fitness[blockNumber.toString()][type] || false;
  };

  const hasAnyFitnessData = (client) => {
    if (!client.fitness) return false;

    for (let block = 1; block <= 4; block++) {
      const blockData = client.fitness[block.toString()];
      if (blockData) {
        if (
          blockData.biometrics === true ||
          blockData.exercises === true ||
          blockData.exercisesCompleted === true
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const yearOptions = useSelector((state) => state.client.yearOptions || []);

  const dropdownYears = React.useMemo(() => {
    if (yearOptions.length === 0) return [];
    const maxYear = Math.max(...yearOptions.map((y) => Number(y)));
    const minYear = 2025;
    const years = [];
    for (let y = maxYear; y >= minYear; y--) {
      years.push(y);
    }
    return years;
  }, [yearOptions]);

  // When yearOptions arrive, default selectedYear to the first option
  useEffect(() => {
    if (!selectedYear && yearOptions.length > 0) {
      const initialYear = yearOptions[0].toString();
      setSelectedYear(initialYear);
      setDisplayedClients([]);
      setPage(1);
      setHasMore(true);
      fetchClients(1, "", initialYear);
    }
  }, [yearOptions, selectedYear]);

  const handleShare = async () => {
    Swal.fire({
      html: `
      <div style="text-align: center; border-radius: 20px; position: relative;">
        <button
          id="customCloseButton"
          style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
          <img
            src=${Close_Button}
            alt="Close"
            style="width: 40px; height: 40px;"
          />
        </button>
        <img
          src=${Suceess}
          alt="Success"
          style="width: 100px; margin-bottom: 10px; margin-top: 15px;"
        />
        <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px;">Are you sure?</h2>
        <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px;">
          Do you really want to send reports to all clients?
        </p>
        <div style="display: flex; gap: 15px; justify-content: center; align-items: center; margin-top: 20px;">
          <button
            id="cancel"
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer;">
            Cancel
          </button>
          <button
            id="ok"
            style="background: white; color: #151515;  padding: 10px 50px; font-family:gothambold; border-radius: 8px; cursor: pointer; border: 1px solid #E27808;  font-size:14px;">
            Send Reports
          </button>
        </div>
      </div>
    `,
      showConfirmButton: false,
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const ok = document.getElementById("ok");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });

        ok.addEventListener("click", async () => {
          Swal.close();
          const success = await sendAllClientsReport();
          if (success) {
            navigate(coachRoutes.listClient);
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.dashboard}>HOME / </Link>
          <span>Clients List</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>CLIENTS LIST</h3>
            </div>
            <div className={Styles.table_container_headingtwo}>
              {/* Share Button */}
              <button
                className={Styles.viewReportBtn}
                onClick={() => handleShare()}
              >
                Share All Report
              </button>
              <div
                className={`${Styles.searchContainerchildtwo} ${
                  searchQuery ? Styles.active : ""
                }`}
              >
                <input
                  type="text"
                  className={Styles.searchInput}
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
                <FaSearch className={Styles.searchIcon} />
              </div>
              <select
                className={Styles.sortselect}
                value={selectedYear}
                onChange={handleYearFilter}
              >
                {dropdownYears.map((year) => (
                  <option key={year} value={year.toString()}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div
            className={`${Styles.tableFixedHeader} ${Styles.tableAlignmentFix}`}
          >
            {!displayedClients || displayedClients.length === 0 ? (
              <div className={Styles.no_sessions_container}>
                <></>
              </div>
            ) : (
              <>
                {/* Fixed Table Header */}
                <div ref={headerTableRef} className={Styles.headerTable}>
                  <table
                    className={`${Styles.exercise_table} ${Styles.table_alignment_fix}`}
                  >
                    <thead className={Styles.stickyHeader}>
                      {/* Main Header Row */}
                      <tr className={Styles.mainHeaderRow}>
                        <th className={Styles.idColumn} rowSpan="2">
                          ID
                        </th>
                        <th className={Styles.nameColumn} rowSpan="2">
                          Client Name
                        </th>
                        <th className={Styles.blockMainHeader} colSpan="2">
                          Block 1
                        </th>
                        <th className={Styles.blockMainHeader} colSpan="2">
                          Block 2
                        </th>
                        <th className={Styles.blockMainHeader} colSpan="2">
                          Block 3
                        </th>
                        <th className={Styles.blockMainHeader} colSpan="2">
                          Block 4
                        </th>
                        <th className={Styles.actionColumn} rowSpan="2">
                          Action
                        </th>
                      </tr>
                      {/* Sub Header Row */}
                      <tr className={Styles.subHeaderRow}>
                        <th className={Styles.biometricsColumn}>Biometrics</th>
                        <th className={Styles.exercisesColumn}>Exercises</th>
                        <th className={Styles.biometricsColumn}>Biometrics</th>
                        <th className={Styles.exercisesColumn}>Exercises</th>
                        <th className={Styles.biometricsColumn}>Biometrics</th>
                        <th className={Styles.exercisesColumn}>Exercises</th>
                        <th className={Styles.biometricsColumn}>Biometrics</th>
                        <th className={Styles.exercisesColumn}>Exercises</th>
                      </tr>
                    </thead>
                  </table>
                </div>

                {/* Scrollable Table Body */}
                <div
                  id="scrollableDiv"
                  ref={scrollableContainerRef}
                  className={Styles.scrollableContainer}
                >
                  <InfiniteScroll
                    dataLength={displayedClients.length}
                    next={fetchClients}
                    hasMore={hasMore}
                    loader={
                      <div className={Styles.infiniteScrollLoader}>
                        <></>
                      </div>
                    }
                    endMessage={
                      <p
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          color: "#f3f3f6",
                          fontFamily: "gotham_bookregular",
                        }}
                      >
                        {displayedClients.length > 0 && ""}
                      </p>
                    }
                    scrollableTarget="scrollableDiv"
                    scrollThreshold={0.8}
                  >
                    <table
                      className={`${Styles.exercise_table} ${Styles.table_alignment_fix}`}
                    >
                      <tbody>
                        {displayedClients
                          .filter((client) => client && client.name)
                          .map((client, index) => {
                            const canViewReport = hasAnyFitnessData(client);

                            return (
                              <tr key={client._id} className={Styles.dataRow}>
                                <td className={Styles.idColumn}>
                                  {client.code ||
                                    `CLIENT${String(index + 1).padStart(
                                      2,
                                      "0",
                                    )}`}
                                </td>
                                <td className={Styles.nameColumn}>
                                  <span title={client.name}>
                                    {client.name?.length > 20
                                      ? `${client.name.slice(0, 20)}...`
                                      : client.name || "N/A"}
                                  </span>
                                </td>

                                {/* Block 1 */}
                                <td
                                  className={`${Styles.biometricsColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getFitnessData(client, 1, "biometrics"),
                                    )}
                                  </span>
                                </td>
                                <td
                                  className={`${Styles.exercisesColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getExerciseStatus(client, 1),
                                    )}
                                  </span>
                                </td>

                                {/* Block 2 */}
                                <td
                                  className={`${Styles.biometricsColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getFitnessData(client, 2, "biometrics"),
                                    )}
                                  </span>
                                </td>
                                <td
                                  className={`${Styles.exercisesColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getExerciseStatus(client, 2),
                                    )}
                                  </span>
                                </td>

                                {/* Block 3 */}
                                <td
                                  className={`${Styles.biometricsColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getFitnessData(client, 3, "biometrics"),
                                    )}
                                  </span>
                                </td>
                                <td
                                  className={`${Styles.exercisesColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getExerciseStatus(client, 3),
                                    )}
                                  </span>
                                </td>

                                {/* Block 4 */}
                                <td
                                  className={`${Styles.biometricsColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getFitnessData(client, 4, "biometrics"),
                                    )}
                                  </span>
                                </td>
                                <td
                                  className={`${Styles.exercisesColumn} ${Styles.statusCell}`}
                                >
                                  <span>
                                    {renderStatusIcon(
                                      getExerciseStatus(client, 4),
                                    )}
                                  </span>
                                </td>

                                <td className={Styles.actionColumn}>
                                  <div
                                    className={Styles.actionButtonsContainer}
                                  >
                                    <button
                                      className={`${Styles.viewReportBtn} ${
                                        !canViewReport ? Styles.disabledBtn : ""
                                      }`}
                                      onClick={() =>
                                        canViewReport &&
                                        handleViewReport(client._id)
                                      }
                                      disabled={!canViewReport}
                                      style={{
                                        opacity: canViewReport ? 1 : 0.5,
                                        cursor: canViewReport
                                          ? "pointer"
                                          : "not-allowed",
                                        backgroundColor: canViewReport
                                          ? ""
                                          : "#424141ff",
                                      }}
                                    >
                                      View Report
                                    </button>

                                    <button
                                      className={Styles.delete_btn}
                                      onClick={() => handleDelete(client._id)}
                                      type="button"
                                    >
                                      {/* Use a fallback if image doesn't load */}
                                      {Delete ? (
                                        <img
                                          src={Delete}
                                          alt="Delete Icon"
                                          className={Styles.delete_icon}
                                        />
                                      ) : (
                                        <span>🗑️</span>
                                      )}
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ListClient;
